import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "e-card-header" }
const _hoisted_3 = { class: "e-card-header-caption" }
const _hoisted_4 = { class: "e-card-header-title" }
const _hoisted_5 = { class: "e-card-content" }

import {computed} from "vue";
import {useDisplay} from "vuetify";

interface Props {
  title?: string;
  flexDirection?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SogPage',
  props: {
    title: { default: "" },
    flexDirection: { default: "flex-row" }
  },
  setup(__props: any) {

const props = __props;

const {height} = useDisplay();
//const {menuSidebarVisible} = storeToRefs(useNavigationStore())

const _contentClass = computed(() =>
  props.flexDirection === "flex-row"
    ? "content content-flex-row"
    : "content content-flex-column"
);

const _style = computed(() => {
  //const t_marginLeft = menuSidebarVisible.value ? "margin-left: 5px;" : ""
  return (
    "min-height: " + (height.value - 100) + "px; justify-content: flex-start;"
  ); //+t_marginLeft
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "e-card card",
      style: _normalizeStyle(_style.value)
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h4", null, _toDisplayString(__props.title), 1)
          ])
        ])
      ]),
      _renderSlot(_ctx.$slots, "top"),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: _normalizeClass(_contentClass.value)
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2)
      ])
    ], 4)
  ]))
}
}

})